import { TabFocusCheck, checkDocument } from '../../customLib';

const tabFocusInstance = TabFocusCheck();

export const initTabFocus = {
	tabInFocus: checkDocument()
		? !document[tabFocusInstance.getVisStateKey()]
		: false,
	focusOutTime: Date.now(),
};

export const tabFocusActions = store => {
	const starTabFocus = () => {
		if (checkDocument()) {
			const { focusOutTime } = store.getState();
			const focusState = !document[tabFocusInstance.getVisStateKey()];

			store.setState({
				tabInFocus: focusState,
				focusOutTime: focusState === false ? Date.now() : focusOutTime,
			});
		}
	};

	return {
		/**
		 * Tab Focus:
		 */
		__tabFocusStart: () => {
			tabFocusInstance.tabFocus(starTabFocus);
		},
		__tabFocusEnd: () => {
			tabFocusInstance.removeFocusEvent(starTabFocus);
		},
	};
};
